var _style, _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _path5, _linearGradient3, _path6, _linearGradient4, _path7, _path8, _path9, _path10, _linearGradient5, _path11, _path12, _path13, _path14, _linearGradient6, _path15, _path16, _linearGradient7, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g2, _g3, _path56, _path57, _linearGradient8, _path58, _g4, _path59;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 269.5 98.8",
    width: 2500,
    height: 917,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:url(#polygon16_1_)}.st1{fill:#0071b9}.st2{fill:url(#polygon25_1_)}.st3{fill:#1d2c5e}.st4{fill:url(#polygon36_1_)}.st5{fill:url(#polygon43_1_)}.st6{fill:#312370}.st7{fill:#21386e}.st8{fill:url(#polygon56_1_)}.st9{fill:url(#path69_1_)}.st10{fill:url(#polygon78_1_)}.st11{fill:#ffcb05}.st12{fill:#7d7f68}.st13{fill:#c7a008}.st14{fill:#3c5aa6}.st15{fill:#3567b0}.st16{fill:#1e2d5f}.st17{fill:#3466af}.st18{fill:url(#path183_1_)}.st19{fill:url(#path196_1_)}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "polygon16_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.751,
    y1: -632.71,
    x2: 416.733,
    y2: -614.042,
    gradientTransform: "matrix(1 0 0 -1 -413.451 -579.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0070b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2c5e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "polygon16",
    className: "st0",
    d: "M0 36.6l12 20.3 4.8-4.6L3.7 32.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "polygon18",
    className: "st1",
    d: "M178.6 20.6l-.5 2.7 5.7-1.9-.7-3.3z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "polygon25_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 548.926,
    y1: -594.572,
    x2: 561.641,
    y2: -580.948,
    gradientTransform: "matrix(1 0 0 -1 -413.451 -579.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0070b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2c5e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "polygon25",
    className: "st2",
    d: "M145 2.3l-18.5 21.2 5.4-1.5 17.6-22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "polygon27",
    className: "st3",
    d: "M244.1 31.3l4.5-2.4-1.3 11.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "polygon29",
    className: "st3",
    d: "M215.8 38.6l4.1.9L225 37l-4.5-1.7z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "polygon36_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 493.453,
    y1: -617.286,
    x2: 491.937,
    y2: -604.548,
    gradientTransform: "matrix(1 0 0 -1 -413.451 -579.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0070b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2c5e"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "polygon36",
    className: "st4",
    d: "M76.6 26.6l.6 13.1 5.7-2.2-1.7-13.4z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "polygon43_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 632.347,
    y1: -614.834,
    x2: 631.742,
    y2: -603.336,
    gradientTransform: "matrix(1 0 0 -1 -413.451 -579.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2c5e"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "polygon43",
    className: "st5",
    d: "M220.2 22.6l-4.5 2.5.1 13.5 4.6-2.3 1.4-6.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "polygon45",
    className: "st6",
    d: "M219.6 39.5l-5 44.4 8-1.6 1.5-45.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "polygon47",
    className: "st7",
    d: "M229.3 86l.2 6 15.3 4.9 4.6-2.4-15.1-11.7-15.2-1.3-4.5 2.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "polygon49",
    className: "st7",
    d: "M172.5 75.4l3.7-2 2.5 4.4 3.5-1.9.7 5.8 22.3 4 4.4-2.5-30.7-18.7-21.8 3.7-4.2 4.1z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "polygon56_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.912,
    y1: -598.261,
    x2: 576.568,
    y2: -619.489,
    gradientTransform: "matrix(1 0 0 -1 -413.451 -579.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125d9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2c5e"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "polygon56",
    className: "st8",
    d: "M165.4 20.8l-4.5 2.5-8 49 4.5-2.4 7.7-27.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "polygon58",
    className: "st3",
    d: "M129.8 27.4l-3.6 1.9.3 1.2 8.5-5.4-3.7-4-4.8 2.4z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "polygon60",
    className: "st7",
    d: "M139.5 85.3l-36.3-18 4.5-3.5 36.3 19z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "polygon62",
    className: "st3",
    d: "M106.6 18.3l-5.5 10.4 5.8-1.7 4.2-11.2z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "path69_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 471.821,
    y1: -632.309,
    x2: 480.919,
    y2: -650.202,
    gradientTransform: "matrix(1 0 0 -1 -413.451 -579.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#105fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2c5e"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "path69",
    className: "st9",
    d: "M56.6 61.4L52 64.6s1 5.2 2.3 8.8c1.3 3.6 4.3 6.5 4.3 6.5 2 1.9 4.3 3.3 7 4.1 5.1 1.5 10.9.5 15.9-2.7 1.3-.8 3.1-2.1 4.2-3.2-4.9 3-29.1-16.7-29.1-16.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "polygon71",
    className: "st3",
    d: "M81.5 38.7l4.2 46.7 17.4-2.5 4.6-2.4-21.5-44.6-4.4 1.5-4.6 2.3z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "polygon78_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 437.492,
    y1: -626.202,
    x2: 448.022,
    y2: -650.612,
    gradientTransform: "matrix(1 0 0 -1 -413.451 -579.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#105fa1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d2c5e"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "polygon78",
    className: "st10",
    d: "M16.5 54.9l19.4 43.9 18.4-5.9 4.5-3-38.2-40-4.8 2.9-3.8 4.1z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "path80",
    className: "st3",
    d: "M208.4 75.6l.3 2.2c1.6-.2 3.2-.4 4.7-.9 1.7-.6 5.3-2.2 6.6-3.4-.6.2-9 2.4-11.6 2.1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "path82",
    className: "st3",
    d: "M143.3 64.4l.7 3.5c3.7-.6 6.9-1.9 10.1-3.8 2-1.2 4.1-2.9 4.8-3.4-.5.3-15.6 3.7-15.6 3.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g84",
    transform: "translate(-5.451 -1.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path86",
    className: "st11",
    d: "M46.4 96.3L45 93.1l-18.4-41-.4-.8-.8.4-.6.3-3.3 1.6c-.5-.8-1.3-2.2-1.8-3.1L12.3 38l-1.9-3.3 3.2-2c3-1.9 6.4-3.7 10.2-5.3 7.4-3.1 14.9-4.8 21.8-4.8 2.3 0 4.5.2 6.5.5 3.4.4 6.6 1.5 9.2 3.3 3.9 2.2 7 5.6 8.7 9.6 1.4 3.3 1.7 7.2.8 11.2l-.5 2.4 2-1.4c1.3-1 2.7-1.8 4.2-2.4 2.6-1.1 5.3-1.7 8-1.7 2.6 0 5 .5 7.2 1.5l1.4.6-.1-1.6-.6-6.7-.1-1.1-1 .3-3.1.8-.5-11.4 22.8-7.3-.2 8.9 1.7.4 5-9.5 14.9 13.2.6.6.6-.6c2-1.9 4.5-3.5 7.2-4.6l1.1-.5-.8-1-2.7-3.3L155 3.1l9 13.4-13.7 7.4-3 1.6 3.5.1c6.5.1 12.3 2.9 16.2 7.7l1.4 1.8.9 1.1-1.5 1.6-1 1.1-3.4 3.7-.6.7.7.6 3.2 2.9 1.2 1.1.3-1.6 1.2-7.6.3-2 .3-2 1.8-11.3h17l.1-.8.3-1.9H204l3.6 22.6.2 1.5 1.2-.9c1.5-1.1 3.1-1.9 4.8-2.6 2.3-.9 4.6-1.3 7-1.3 2.8 0 5.5.6 7.8 1.9.1 0 .1.1.3.2l1.1.4.1-1.2.3-2.5.1-.8-.8-.2-3-.7-.1-11.8 22.9 5 1.7 8.5h1.8l1.8-7.3 19.1 4.6L254.3 95l-13.9-4.4-.1-5.4v-.8l-.8-.1-13.9-2 .8-7.1.2-1.7-1.5.8c-.7.4-1.4.7-2.1.9-2.3.9-4.6 1.3-6.9 1.3-.7 0-1.3 0-2-.1l-1.2-.1.2 1.2 1 6.2-20.3-3.6-1.1-9.2-.3-3-1.4 2.6-2.3 4.5-4.3-7.9-1.3-2.4-.4 2.7-.9 6.1-17.8-2.8 1.4-8.4.3-1.9-1.7 1c-2.9 1.7-6.3 3.1-10.2 4-1.4.3-2.8.6-4.3.7l-.8.1V83l-35-17.3-1.3-.6v16.3l-15.7 2.3-.7-7.1-.2-1.9-1.4 1.3c-2.1 2-4.4 3.6-6.9 4.7-2.6 1.1-5.3 1.7-7.9 1.7-2.7 0-5.2-.6-7.5-1.6-4.2-2-7.3-5.7-8.6-10.4-.6-2.2-.8-4.5-.5-6.9l.3-2.5-1.8 1.8c-1.3 1.2-2.7 2.4-4.2 3.5l-.5.4.2.6 5.3 20.2.9 3.6-3.5 1.1-9.9 3.2-3.4.9zM50.8 42c-.5 0-1 0-1.6.1l-.7.1-1 .2.3 1 .2.6 2.8 9.3.3.9.4 1.3 1-.9.7-.6c2.8-2.5 3.7-5 3.1-8.2-.4-1.9-1.8-2.8-2.7-3.2-.6-.4-1.7-.6-2.8-.6zm76.2.3l-1.8 1.7-4.7 4.5-1 1 1.3.5 5 1.9 1.5.6-.3-1.6c-.4-2.1-.5-4.2-.3-6.2l.3-2.4zm20.4-5.2c-1.9 0-3.8.8-5.1 2.3-2 2.2-2.4 5.5-1 8.1l.4.7.6 1.1.9-1 .6-.6 6.9-7.8.5-.6.9-1-1.2-.5-.8-.3c-1-.2-1.8-.4-2.7-.4z"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "path88",
    className: "st12",
    d: "M152.4 47l-.2.2c.1 0 .2-.1.2-.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "polygon90",
    className: "st12",
    d: "M158.4 41.6l3.4-3.7-1.2 1.2V39l-1 1.1-3.4 3.6 3.2 2.9.6-3.6 1.6 1.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "polygon92",
    className: "st12",
    d: "M158.4 41.6l3.2 2.8 1.2-7.6-1 1.1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "path94",
    className: "st12",
    d: "M115.7 47.5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "path96",
    className: "st13",
    d: "M134.7 50.7c.3.3 0 .1.3.3l2.1-1.5c-.3-.2-.6-.5-.9-.7-3-2.8-2.2-9-.3-12.4-5.2 4.2-4.9 10.6-1.2 14.3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "path98",
    className: "st13",
    d: "M160 54.2c-3.5 2.9-7.4 4.7-12.6 6-1.1.3-2.3.5-3.3.5-8.3.8-15.2-3-17.8-9.1-.3-.7-.6-1.5-.8-2.3-1.2-5.2-.2-9.8 2.4-13.5.3-.4.5-.7.8-1-.1.1-.3.2-.4.3-1 .9-1.9 1.8-2.6 2.9-2.6 3.6-3.6 8.3-2.4 13.5.2.8.4 1.6.8 2.3 2.6 6.2 9.6 10 17.8 9.2 1.1-.1 2.2-.3 3.4-.6 5.2-1.3 9.2-3.1 12.6-6 .8-.7 1.7-1.5 2.5-2.3l-.1-.1c-.2.1-.3.1-.3.2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "polygon100",
    className: "st13",
    d: "M101.7 38.5l9.2-13-.4-.3-8.9 12.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "polygon102",
    className: "st13",
    d: "M162.8 36.8l-1.2 7.6L160 43l-.6 3.6-3.2-2.9 3.4-3.6 1-1.1v.1l1.2-1.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "polygon104",
    className: "st13",
    d: "M151.4 15.4l3.2-1.4-5.9-7.6-1.9 2.8z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "path106",
    className: "st13",
    d: "M61.8 34.2c-15-18.2-41.9-8.4-51.5.1l.4.7c2.2-1.3 4.6-2.4 7-3.5 9.6-4.1 18.8-5.3 26.1-4 2.6.3 5.3 1.1 7.7 2.7 3.3 1.9 5.8 4.5 7.3 7.9 2.6 6 .3 14-5.8 20.6 7.7-7.1 13-13.9 8.8-24.5z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "path108",
    className: "st13",
    d: "M92.3 55.4c-.1-.3-.1-.7-.2-1-.8-3-2.6-5.4-5-7-3.8-2.6-9.2-3.1-14.5-.9-2.8 1.2-5.2 3.1-7.2 5.3 1.5-1.3 3.2-2.3 5-3.1 5.3-2.3 10.7-1.7 14.5.9 2.4 1.6 4.2 4 5 7 .1.3.2.7.2 1 .2 1.2.3 2.3.3 3.5-.1 3.5-1.4 7-3.5 10-.3.5-.7.9-1.1 1.4 1.2-1.1 2.3-2.2 3.2-3.5 2.2-3 3.4-6.5 3.6-10 0-1.2-.1-2.4-.3-3.6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "path110",
    className: "st13",
    d: "M77.6 51s2.2-2.2 2.1-2.2c-2.7-.1-3.9 2.5-4 2.7.6-.3 1.2-.4 1.9-.5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "path112",
    className: "st13",
    d: "M82.7 54.1c.1.4.2.7.2 1.1 0 .6-.1 1.1-.4 1.6.4-.2 3.6-1.8 2.4-5 .1.2-2.3 2.3-2.2 2.3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "path114",
    className: "st13",
    d: "M70.3 56c0-1.3 2.3-4.6 3-5.7-3.6 2.3-5.2 5.4-5.2 7.8 0 4.2 3.7 7.6 8.1 7.6 2.1 0 5.9-1.1 8.4-5.1-1.3.9-4.6 2.9-6.4 2.9-4.4 0-7.9-3.3-7.9-7.5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "polygon116",
    className: "st13",
    d: "M101.2 59.8l.1 16.9 2.7.2-.6-19.3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "polygon118",
    className: "st13",
    d: "M85.8 27.5V29l12.8-3.8.9 16.3 2.2-3-.5-16.3z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "polygon120",
    className: "st13",
    d: "M124.3 33.3l-11.9-11-1.5 3.2 10.6 9.9z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "path122",
    className: "st13",
    d: "M122.5 53.8l-14.1-4.7-2 2.2 14 5.6c1.6 3 4 5.6 7 7.4 2.9 1.8 6.3 2.9 9.8 3.2v6.9l2.2 1.1.7-10.4-17.6-11.3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "path124",
    className: "st13",
    d: "M145.1 51.9c3.5-.8 5.4-2.6 7.2-4.6-1.3 1.1-7.7 2.5-8.8 2.8l-2.1 2.3c.9 0 2.5-.2 3.7-.5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "path126",
    className: "st13",
    d: "M138.8 27.9c-6.4.8-9.7 6.2-10.2 6.8 2.4-2 5.3-3.5 8.6-4.2 7.9-1.9 14.8.5 19.1 5.8l2.7-2.2c-4.3-5.2-12.3-8.1-20.2-6.2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "path128",
    className: "st13",
    d: "M160.2 54c.8-.6 2.1-1.3 2.9-2.1l-8.5-7.6c-.7.8-1.2 2.1-2 2.7l7.6 7z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "path130",
    className: "st13",
    d: "M203.9 74.4c-8.9-7.4-8.4-23.1-4-28.1L196 21.6l-8.6 1.1-.4 2.2h6.5l3.5 22.4c-4.4 5-6.5 11.7-5.1 17.9 1.1 4.8 4.1 8.6 8.3 10.8.4.2.9.4 1.3.6l.1.3 2.6.4c-.1.1.2-2.7-.3-2.9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "polygon132",
    className: "st13",
    d: "M169.6 25.2l-.4 2.2h9.8l2.9 15.9 2.2-2.2-2.3-16.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "polygon134",
    className: "st13",
    d: "M186.4 56l-3.2 8.2.8 2.2 4.5-12.5z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "polygon136",
    className: "st13",
    d: "M177 50.9l-2.2 2.2-2.4 14.8 2.3.8z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "path138",
    className: "st13",
    d: "M221.1 46.1c1.3.9 2.4 2.1 3.2 3.5.7 1.1 1.1 2.2 1.5 3.6 1.1 4.5-.2 9.3-3 13.1-.3.4-.6.8-.9 1.1 1.1-1 15.1-11.3 1.5-24.8-15-4.9-20.7 4.8-21.2 5.5 1.6-1.3 3.4-2.5 5.4-3.2 5-2 10-1.3 13.5 1.2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "path140",
    className: "st13",
    d: "M213.6 47.1c0 .1 2.2-2.2 2.2-2.2-2.7.1-4 1.4-3.8 2-.2.2-.3.5-.4.7.5-.3 1.6-.5 2-.5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "path142",
    className: "st13",
    d: "M218.6 50.5c.1.4.1.7.1 1.1 0 .5-.2 1-.4 1.4.4-.2 3.6-1.2 2.4-4.8.1.2-2.2 2.3-2.1 2.3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "path144",
    className: "st13",
    d: "M211.5 61.8c3 .1 6.4-1.7 8.8-5-6.1 1.3-12.6-9-12-10-2.3 1.7-4.4 4.9-4.5 7.2-.2 4.2 3.3 7.6 7.7 7.8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "polygon146",
    className: "st13",
    d: "M245.2 88.5l1.4.9 17.6-52.8-13.2-3-.1 3.1 10.6 2.3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "polygon148",
    className: "st13",
    d: "M224.3 27.9l.1 3 14 2.8 5.4 25.6 2.2-2.2-5.2-25.9z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "polygon150",
    className: "st13",
    d: "M235.1 57.1l-3.9 21.8 2.2.7 3.9-24.7z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "polygon152",
    className: "st13",
    d: "M53.4 86.9l-6.5-23.8-2.4 1.7 6.1 22.7z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "path154",
    className: "st13",
    d: "M51.7 51.2c-1.5 1.6-4.9 4.7-6.8 5.9l-1.2-3.7-2.5-8.2-1.6-5.5-1.6 2 1.6 5.5 2.5 8.1 1.2 3.7c2.7-1.5 6.5-4.7 8.4-7.8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "path156",
    className: "st12",
    d: "M144.5 37.1c-2.1-.8-5-.6-6.6 1.2-.4.4-1.1 1.4-1.3 1.9 1.5-1.2 4.3-1.5 6-.8l1.9-2.3z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "path158",
    className: "st12",
    d: "M49.9 44.5c-.2-1.2-1.4-2.2-2-2.5-1-.5-2.9-.6-4.2-.3.2.8.5 1.8.6 2.2.5.1 1.4.2 1.9.4.6.3 1.6.9 1.8 2.2.3 1.6.2 3.2-.5 4.4 1.9-1.8 2.8-3.8 2.4-6.4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "g160",
    transform: "translate(-5.451 -1.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g162"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path164",
    className: "st14",
    d: "M58.6 46.1c-.9-4.8-7.2-7.5-13.5-4.1l1.6 5.5 2.5 8.2 1.2 3.7c4.7-2.9 9.4-6.6 8.2-13.3zm-6.2 7.5c-.7-2.2-2.2-7-2.2-7s-.3-1-.7-2.2c1.3-.2 2.6-.1 3.6.4.6.3 1.6.9 1.8 2.2.6 2.6-.3 4.6-2.5 6.6z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "g166",
    transform: "translate(-5.451 -1.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g168"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path170",
    className: "st15",
    d: "M153.2 38.5c-3.5-3.2-8.9-3-12.1.5-3.2 3.5-3 8.9.5 12.1.3.3.6.5.9.7L153.8 39c-.2-.1-.4-.3-.6-.5zm-10.6 9c-1.1-2-.9-4.6.8-6.4 1.6-1.7 4-2.2 6.1-1.4l-6.9 7.8z"
  })))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "polygon172",
    className: "st16",
    d: "M162.8 35.4l-6.2 6 5.9 5.3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "path174",
    className: "st17",
    d: "M220.7 48.3c.1.4.1.8.1 1.2-.1 2.4-2.3 4.2-5 4.1-2.7-.1-4.8-2.1-4.7-4.5.1-2.2 2.1-4 4.5-4.1-.5-.1-1-.2-1.5-.2-4.5-.2-8.1 3-8.3 6.9-.2 4.2 3.2 7.7 7.6 7.8 4.5.2 8.1-3 8.3-7.2.3-1.4-.2-2.8-1-4"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "path183_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 639.706,
    y1: 2062.77,
    x2: 655.635,
    y2: 2062.77,
    gradientTransform: "translate(-569.451 -2006.686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c5aa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#2b73b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a75bb"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "path183",
    className: "st18",
    d: "M85.1 53.1c0 2.4-2.2 4.3-4.8 4.3-2.7 0-4.8-1.9-4.8-4.3 0-2.2 1.9-4.1 4.4-4.3-.5-.1-1-.1-1.5-.1-4.5 0-8 3.3-8 7.3 0 4.2 3.5 7.5 7.9 7.5 4.5 0 8-3.3 8-7.5 0-1.5-.5-2.8-1.3-4 0 .3.1.7.1 1.1"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "g185",
    transform: "translate(-5.451 -1.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g187"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "path196_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 578.628,
    y1: 2056.257,
    x2: 844.371,
    y2: 2056.257,
    gradientTransform: "translate(-569.451 -2006.686)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c5aa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933,
    stopColor: "#2b73b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a75bb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    className: "st19",
    d: "M254 30.6l-2 8.2-1.8-9.1-24.6-5.4.2 13.7 3.7.8-.3 2.5s-.1 0-.1-.1c-4.6-2.4-10.3-2.7-15.6-.6-1.8.7-3.5 1.6-5 2.7l-3.7-23.4h-16.3l-.4 2.7h-17.2l-2 12-1.4-1.8c-4.2-5.1-10.2-7.9-16.9-8.1l14.6-7.8L155 1.7l-18.4 21.2 3.2 3.9c-2.9 1.2-5.4 2.8-7.5 4.8l-15.8-14-5.5 10.5.2-10.2-24.7 7.9.7 13.2 4.2-1.1.6 6.7c-4.8-2.2-10.6-2.1-15.9.2-1.6.7-3.1 1.5-4.4 2.5.9-4.1.7-8.1-.9-11.7-1.8-4.2-5.1-7.8-9-10-2.8-1.9-6.1-3-9.6-3.4-8.5-1.5-18.8 0-28.9 4.3-3.7 1.6-7.2 3.4-10.3 5.4l-3.9 2.5 2.4 4L18.9 51l2.3 3.8 4-2 .6-.3 18.4 41 1.8 3.9 4.1-1.3 9.9-3.2 4.4-1.4-1.1-4.4L58 66.9c1.5-1.1 2.9-2.3 4.2-3.6-.3 2.4-.1 4.9.5 7.2 1.4 4.9 4.6 8.8 9.1 10.9 4.8 2.3 10.7 2.3 16.1 0 2.7-1.2 5.2-2.8 7.2-4.9l.7 8.1 17.4-2.6V66.4l36.3 18V67.1c1.5-.1 2.9-.4 4.4-.7 4-1 7.4-2.3 10.5-4.1l-1.5 9.3 19.6 3.1 1.1-7.1 5.1 9.5 3.1-6 1.1 9.9 22.2 3.9-1.2-7.5c3 .3 6.2-.1 9.3-1.2.7-.3 1.5-.6 2.1-1l-.9 8 14.8 2.1.1 6.1 15.4 4.8 20.1-60.5-20.8-5.1zm-86.8 9l1-1.1-1.2 7.6-3.2-2.9 3.4-3.6zm-13-31.2l5.4 7.3-15.4 7.6-1.1-1.6c0 .1 11.1-13.3 11.1-13.3zM52.3 64.8l6.1 23.6-9.9 3.2L28.1 46c-1.1.6-3.2 1.6-5 2.5L15.7 36c2.9-1.9 6.2-3.5 9.6-5 9.6-4.1 18.8-5.3 26.1-4 2.6.3 5.3 1.1 7.7 2.7 3.3 1.9 5.8 4.5 7.3 7.9 3.6 8.2-2.3 20-14.1 27.2zM98 60.6c-.1 3.5-1.4 7-3.6 10-2.1 2.9-4.9 5.2-8.3 6.7-8.6 3.7-17.2 0-19.5-8.2-2.2-7.9 3-17.3 11.3-20.9 5.3-2.3 10.7-1.7 14.5.9 2.4 1.6 4.2 4 5 7 .1.3.2.7.2 1 .4 1.2.4 2.4.4 3.5zm46.9 16.7l-36.1-18 .1 18.9-9.3 1.3-.7-7.8c2.9-4.9 3.9-10.8 2.4-16.1-.8-2.9-2.3-5.5-4.4-7.5l-1.3-15.9-4.2 1.1-.2-4 15-4.5.9 15.4 11-15.5L129 35l-15.1 15.9 14.2 5.6c1.6 3 4 5.5 7 7.4 2.9 1.8 6.3 2.9 9.8 3.2v10.2zm-18.7-26.2l-5-1.9 4.7-4.5c-.3 2.1-.2 4.2.3 6.4zm39.2 4.8c-3.5 2.9-7.4 4.7-12.6 6-1.1.3-2.3.5-3.3.5-8.3.8-15.2-3-17.8-9.1-.3-.7-.6-1.5-.8-2.3-1.2-5.2-.2-9.8 2.4-13.5.7-1.1 1.6-2 2.6-2.9 2.4-2.2 5.5-3.7 9-4.6 7.9-1.9 14.8.5 19.1 5.7l-15 16c1 .2 2.6-.1 3.8-.4 3.6-.9 5.6-2.8 7.3-4.8l6 5.4 1.8 1.6c-.8.9-1.6 1.7-2.5 2.4zm31.9 21.3L194 55.6l-4.6 11.9-6.9-14.9h-.1l-2.7 17.3-11.5-2 1.6-9.6c.4-.4.9-.8 1.3-1.3l3.7-3.8-3.6-3.3 3.9-23h11.6l2.9 15.9 3.3-18.4h8.3l3.5 22.4c-4.4 5-6.5 11.7-5.1 17.9 1.1 4.8 4.1 8.6 8.3 10.9.4.2.9.4 1.3.6l.4 2.9-12.3-1.9zm28.7-7.1c-1.3.9-2.7 1.7-4.2 2.2-3 1.1-5.9 1.4-8.6.8-1.8-.4-3.5-1.1-5-2.1-2.3-1.7-4-4.1-4.8-7.2-.9-3.7-.1-7.7 1.9-11.2 1-1.7 2.3-3.3 3.8-4.7 1.7-1.5 3.7-2.8 5.8-3.6 5.1-1.9 10.1-1.2 13.6 1.3 1.3.9 2.4 2.1 3.2 3.5.6 1.1 1.1 2.3 1.4 3.6 1.1 4.5-.2 9.3-3 13.1-.9 1.7-2.4 3.1-4.1 4.3zm26 20.4l-8.5-2.5-.7-31.4-4.3 24.2-9.3-1.5.7-7c6.1-5.1 9.3-13.2 7.5-20.6-.8-3.2-2.4-6.1-4.8-8.2l.8-8.2-3.5-.9.1-4.4 16 3.2 5.4 25.5 5.5-22.9 12.2 2.7-17.1 52z"
  })))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "M258 85.3h.4c.5 0 .9-.2.9-.7 0-.3-.3-.7-.9-.7h-.4v1.4zm0 2.1h-.6v-3.8c.3-.1.6-.1 1.1-.1.6 0 1 .1 1.2.3.2.2.4.4.4.8 0 .5-.3.8-.7.9.3.1.6.4.6.9.1.6.2.8.2.9h-.6c-.1-.1-.2-.5-.3-1-.1-.5-.3-.7-.8-.7h-.5v1.8zm.7-4.9c-1.5 0-2.7 1.3-2.7 2.9 0 1.6 1.2 2.9 2.8 2.9 1.5 0 2.7-1.3 2.7-2.9-.1-1.6-1.3-2.9-2.8-2.9zm0-.5c1.9 0 3.3 1.5 3.3 3.4s-1.5 3.4-3.4 3.4-3.4-1.5-3.4-3.4c.1-1.9 1.6-3.4 3.5-3.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0d557d6f6072d0f8ee9007b1d08dae0a.svg";
export { ForwardRef as ReactComponent };